import { BookOpen } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function AssessmentGuideNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={BookOpen} selected={selected} />;
}
